import { defineComponent as _, computed as a, openBlock as v, createElementBlock as b, normalizeClass as y, unref as o, createVNode as c, Transition as x, withCtx as p, renderSlot as I, createBlock as P, resolveDynamicComponent as U, createCommentVNode as S, mergeModels as E, useCssVars as O, useModel as X, ref as $, createElementVNode as L, normalizeStyle as T } from "vue";
import { getIconComponent as B, u as z, s as H, X as K, _ as F } from "../kittchat.es.js";
import { s as W, r as j, V as e, h as q, K as G, F as J } from "./KittChat.CFBaYI0_.js";
const Q = /* @__PURE__ */ _({
  __name: "FloatingBox",
  props: {
    position: {}
  },
  setup(l) {
    const i = j(l.position), t = a(() => {
      switch (i.value) {
        case "UL":
        case "UR":
          return "slide-down";
        case "CL":
          return "slide-right";
        case "CR":
          return "slide-left";
        default:
          return "slide-up";
      }
    });
    return (d, f) => (v(), b("div", {
      class: y([
        "widget",
        `widget--${o(i)}`
      ]),
      "data-testid": "widget"
    }, [
      c(x, {
        name: t.value,
        appear: ""
      }, {
        default: p(() => [
          I(d.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 2));
  }
}), Y = /* @__PURE__ */ W(Q, [["__scopeId", "data-v-6ec2e81b"]]), Z = /* @__PURE__ */ _({
  __name: "DynamicIcon",
  props: {
    name: {}
  },
  setup(l) {
    const i = l, t = a(() => B(i.name) || null);
    return (d, f) => t.value ? (v(), P(U(t.value), { key: 0 })) : S("", !0);
  }
}), ee = {
  key: 0,
  class: "animation-wrapper"
}, w = 1, te = 38, oe = /* @__PURE__ */ _({
  __name: "KittChatDesktop",
  props: /* @__PURE__ */ E({
    config: {},
    isTyping: { type: Boolean }
  }, {
    modelValue: {
      default: []
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ E(["sendMessage", "showChat"], ["update:modelValue"]),
  setup(l, { expose: i }) {
    O((C) => ({
      "0dd85b8c": m.value.width,
      d937c7be: m.value.height,
      "35c63950": m.value.borderRadius,
      a7c98a98: o(u).actionColor.base,
      "2cb781e9": t.config.zIndex,
      "3ab78132": o(u).fontColor,
      "6a203aac": o(u).backgroundColor.base,
      "1f1dea88": o(u).backgroundColor.contrasted
    }));
    const t = l, d = X(l, "modelValue"), { height: f } = z(), u = H(), n = $(
      t.config.showClosed ? e.COLLAPSED : e.EXPANDED
    ), { clear: h } = K({
      enabled: !t.config.showClosed,
      delay: t.config.closeTime || 0,
      callback() {
        n.value = e.COLLAPSED;
      }
    }), V = a(() => n.value === e.COLLAPSED), D = a(() => n.value === e.EXPANDED), A = a(() => ({
      [e.COLLAPSED]: {
        width: "0px",
        height: "0px",
        margin: w,
        borderRadius: "100%"
      },
      [e.EXPANDED]: {
        width: "420px",
        height: `${Math.min(550, f.value - w * 2)}px`,
        margin: w,
        borderRadius: u.borderRadius || ".42rem",
        headerHeight: te
      }
    })), m = a(() => A.value[n.value]), k = a(
      () => n.value === e.EXPANDED ? "ChevronDownIcon" : t.config.deviceStyleConfig.icon || "MessagesIcon"
    ), s = a(() => t.config.deviceStyleConfig.position || "LR"), R = a(() => s.value === "UL" || s.value === "UR" ? "bottom" : "top");
    function M() {
      h(), n.value = e.COLLAPSED;
    }
    function N() {
      h(), n.value = V.value ? e.EXPANDED : e.COLLAPSED;
    }
    return i({
      collapse: M
    }), (C, r) => (v(), P(o(Y), {
      position: s.value,
      class: "floating-chat",
      onMouseenter: o(h)
    }, {
      default: p(() => [
        L("div", {
          class: y(["floating-chat__container flex gap-4", [
            s.value === "LR" || s.value === "UR" || s.value === "CR" ? "items-end right" : "items-start left",
            s.value === "UR" || s.value === "UL" ? "flex-col-reverse top" : "flex-col bottom"
          ]])
        }, [
          c(x, { name: "scale-fade" }, {
            default: p(() => [
              D.value ? (v(), b("div", ee, [
                c(o(q), {
                  style: T(m.value),
                  class: "floating-chat__window"
                }, {
                  default: p(() => [
                    c(G, {
                      modelValue: d.value,
                      "onUpdate:modelValue": r[0] || (r[0] = (g) => d.value = g),
                      "is-typing": C.isTyping,
                      onCollapse: r[1] || (r[1] = (g) => n.value = o(e).COLLAPSED),
                      onSendMessage: r[2] || (r[2] = (g) => C.$emit("sendMessage", g))
                    }, null, 8, ["modelValue", "is-typing"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ])) : S("", !0)
            ]),
            _: 1
          }),
          L("div", null, [
            c(o(J), {
              class: "floating-chat_tab",
              open: D.value,
              position: R.value,
              "show-chevron": !1,
              onClick: N,
              "data-testid": "floatingTrigger"
            }, {
              default: p(() => [
                c(Z, {
                  name: k.value,
                  class: "w-8 h-8 relative right-0.5"
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["open", "position"])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["position", "onMouseenter"]));
  }
}), le = /* @__PURE__ */ F(oe, [["__scopeId", "data-v-1dc6ca03"]]);
export {
  le as default
};
//# sourceMappingURL=KittChatDesktop.Dc8hYtjG.js.map
